// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"JQ-z","upvoteIcon":"KQ-z","downvoteIcon":"LQ-z","feedbackIcon":"MQ-z"};